import { ApiEpSharedPostData, FailureApi } from "@smp/api";
import { Await } from "@smp/utils";
import { useQuery, UseQueryOptions } from "react-query";

const KEY = "ep.sharedpostdata.read";

type PathId = Parameters<typeof ApiEpSharedPostData.read>[0]["path"]["id"];
type Response = Await<ReturnType<typeof ApiEpSharedPostData.read>>;

export const useQuerySharedPostData = (
  id: PathId | undefined,
  options?: Omit<UseQueryOptions<Response, FailureApi>, "queryKey" | "queryFn">,
) =>
  useQuery<Response, FailureApi>(
    KEY,
    () => ApiEpSharedPostData.read({ path: { id: id || "" } }),
    {
      ...options,
      enabled: !!id && options?.enabled,
    },
  );

useQuerySharedPostData.KEY = KEY;
